import { render, staticRenderFns } from "./DynamicCoinCounter.vue?vue&type=template&id=be215136"
import script from "./DynamicCoinCounter.vue?vue&type=script&lang=js"
export * from "./DynamicCoinCounter.vue?vue&type=script&lang=js"
import style0 from "./DynamicCoinCounter.vue?vue&type=style&index=0&id=be215136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports